import * as z from 'zod';

export type WorkingHoursExceptionsFormSchemaValues = z.infer<typeof workingHoursExceptionsFormSchema>;
export const workingHoursExceptionsFormSchema = z.object({
    all_day: z.boolean(),
    start_time: z.string().or(z.null()),
    end_time: z.string().or(z.null()),
    date: z.string().nonempty(),
    is_open: z.boolean(),
    description: z.string().nonempty(),
    zone: z.string().nonempty(),
});
